import { SHOW_NOTIFICATION } from '../types';

export const errHandler = (e, dispatch, message = 'Wystąpił nieznany błąd') => {
  const msg = e.message;
  switch(msg) {
    case 'Network Error':
        dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'error', message: 'Wystąpił błąd sieci' }})
        break;
    default:
      dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'error', message }})
  }
  console.log(JSON.stringify(e, null, 2));
}

export const getError = (e) => {
  if (e.name !== 'Error') return { status: 200, message: 'No error detected' };
  const msg = e.message;
  switch(msg) {
    case 'Network Error':
      return { status: 502, message: 'Network Error' };
    case 'Request failed with status code 401':
      return { status: 401, message: 'Not authenticated' };
    default:
      return { status: 0, message: msg }
  }
}